export function bnr() {
  const bnr = document.querySelector('.js-bnr');

  window.addEventListener('scroll', () => {
    const scrollPosition = window.scrollY + window.innerHeight;
    const pageHeight = document.documentElement.scrollHeight;

    if (scrollPosition >= pageHeight - 1) {
      bnr.classList.add('is-hidden');
    } else {
      bnr.classList.remove('is-hidden');
    }
  });
}